import { Link } from "react-router-dom";
import Icon from "../icons";
import PageHero from "../PageHero";
import SiteLayout from "../SiteLayout";

const NotFound = () => (
  <SiteLayout>
    <PageHero
      compact
      eyebrow="404 · Page not found"
      title={<>This path ends here. <span>The good ones don’t.</span></>}
      description="The page may have moved, but the rest of the site is right where you left it."
    >
      <div className="hero-actions">
        <Link className="button" to="/">Back to CMJ <Icon name="arrow" /></Link>
        <Link className="button button-secondary" to="/services">Explore services</Link>
      </div>
    </PageHero>
  </SiteLayout>
);

export default NotFound;
